import { ALL_EMPLOYEES_QUERY } from "../../../graphql/Employees/Employees.graphql";
import { ALL_DRUG_TEST_CATEGORIES_QUERY } from "../../../graphql/DrugTests/DrugTestCategories.graphql";
import { ALL_DRUG_TESTS_QUERY } from "../../../graphql/DrugTests/DrugTests.graphql";
import { ALL_EMPLOYEE_CERTIFICATIONS_QUERY } from "../../../graphql/EmployeeCertifications/EmployeeCertifications.graphql";
import { ALL_VEHICLES_VIEW_BY_PAGE_QUERY } from "../../../graphql/Vehicles/Vehicles.graphql";

const { REACT_APP_REPORT_BASE_URL = "https://gdev.gravoc.com" } = process.env;

export default {
  name: "HR Management",
  label: "HR",
  icon: "users-cog",
  permissions: ["ADMIN", "HR"],
  active: location => location.pathname.includes("hr"),
  links: [
    {
      name: "Employees",
      links: [
        {
          name: "Employees",
          to: "/hr/employees",
          query: ALL_EMPLOYEES_QUERY,
          filters: "EMPLOYEE_FILTERS"
        },
        {
          name: "Certifications",
          to: "/hr/certifications",
          query: ALL_EMPLOYEE_CERTIFICATIONS_QUERY
        },
        {
          name: "Reports",
          links: [
            {
              name: "Address Report",
              href: `${REACT_APP_REPORT_BASE_URL}/ReportViewer/ReportViewer.aspx?Path=Employee%20Address%20Listing`
            },
            {
              name: "Driver Work History",
              href: `${REACT_APP_REPORT_BASE_URL}/ReportViewer/ReportViewer.aspx?Path=Driver%20Work%20History`
            },
            // {
            //   name: "Vacation Report",
            //   href: `${REACT_APP_REPORT_BASE_URL}/ReportViewer/ReportViewer.aspx?Path=Vacation%20Personal%20Days%20Listing`
            // },
            {
              name: "Employee Labels",
              href: `${REACT_APP_REPORT_BASE_URL}/ReportViewer/ReportViewer.aspx?Path=Employee%20Labels`
            },
            {
              name: "Employee Phone Listing",
              href: `${REACT_APP_REPORT_BASE_URL}/ReportViewer/ReportViewer.aspx?Path=Employee%20Phone%20Listing`
            },
            {
              name: "Exam Report",
              href: `${REACT_APP_REPORT_BASE_URL}/ReportViewer/ReportViewer.aspx?Path=Certification%20and%20Exam%20Expiration%20Listing`
            },
            {
              name: "Notes Report",
              href: `${REACT_APP_REPORT_BASE_URL}/ReportViewer/ReportViewer.aspx?Path=Employee%20Notes%20Listing`
            }
          ]
        }
      ]
    },
    {
      name: "Drug Test",
      links: [
        {
          name: "Test Categories",
          to: "/hr/drug-test-categories",
          query: ALL_DRUG_TEST_CATEGORIES_QUERY,
          filters: "DRUG_TEST_CATEGORY_FILTERS"
        },
        {
          name: "Drug Tests",
          to: "/hr/drug-tests",
          query: ALL_DRUG_TESTS_QUERY,
          filters: "DRUG_TEST_FILTERS"
        },
        {
          name: "Vehicle Maintenance",
          to: "/fleet/vehicles",
          query: ALL_VEHICLES_VIEW_BY_PAGE_QUERY,
          filters: "VEHICLE_FILTERS"
        }
      ]
    }
  ]
};
